import { render, staticRenderFns } from "./NCAdminLanding.vue?vue&type=template&id=109fb18f&scoped=true&"
import script from "./NCAdminLanding.vue?vue&type=script&lang=js&"
export * from "./NCAdminLanding.vue?vue&type=script&lang=js&"
import style0 from "./NCAdminLanding.vue?vue&type=style&index=0&id=109fb18f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109fb18f",
  null
  
)

export default component.exports